import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import {Button, Card, Checkbox, Col, Form, Input, message, Row, Select} from "antd";
import {
    fetchWhiteLabelData,
    loadUser,
    login,
    requestVerification,
    verifyUser2FA, verifyUserDevice
} from "../../actions/auth";
import {displayErrors, getCookieValue} from "../../libs/utils";
import {Link, Redirect} from "react-router-dom";
import {updatePage} from "../../actions/page";
import qs from "qs";
import getBrowserFingerprint from 'get-browser-fingerprint';

class Login extends React.Component  {
    state = {
        loading: false,
        step: 1,
        email: '',
        password: '',
        remember: false,
        emailNotVerified: false,
        requestingVerification: false,
        viewPassword: false,
        showWhiteLabelPage: false,
        whiteLabelDataLoaded: false,
        whiteLabelLogo: null,

        show2FA: false,
        user2FASessionId: '',
        user2FACode: '',
        verifying: false,
        user2FACodeType: 'CODE',

        registrationSuccess: false,

        fingerprint: null,

        showDeviceVerification: false,
        deviceVerificationCode: '',
        deviceVerificationSessionId: '',
        rememberDeviceVerification: true,
        verifyingDevice: false,
    };

    componentDidMount() {
        this.props.updatePage('Login');

        getBrowserFingerprint({hardwareOnly: false}).then(result => this.setState({ fingerprint: result }));

        if(typeof(this.emailInput) !== 'undefined') {
            this.emailInput.focus();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.show2FA && this.tfaInput !== null) {
            this.tfaInput.focus();
        } else if(this.state.showDeviceVerification && this.deviceVerificationInput !== null) {
            this.deviceVerificationInput.focus();
        }
    }

    returnToPath() {
        const uri = new URLSearchParams(window.location.search)
        if(uri.has('return')) {
            const { history } = this.props
            history.push(uri.get('return'));
        }
    }

    login() {
        let email = this.state.email.trim();
        let password = this.state.password.trim();

        if(email.length === 0) {
            return message.error('Please enter your email address!');
        }

        if(password.length === 0) {
            return message.error('Please enter your password!');
        }

        const fingerprint = this.state.fingerprint;

        let data = { email, password, fingerprint};

        window.location.search.substring(1).split('&').forEach(value => {
           let pieces = value.split('=');
           data[pieces[0]] = pieces[1];
        });

        if(window.location.search === '') {
            ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term'].forEach(value => {
                if(getCookieValue(value) !== '') {
                    data[value] = getCookieValue(value);
                }
            })
        }

        this.setState({ loading: true });

        this.props.login(data, (res) => {
            if(typeof res.data.session_id !== 'undefined' && typeof res.data.verification !== 'undefined' && res.data.verification === '2fa') {
                this.setState({user2FASessionId: res.data.session_id, show2FA: true});
            } else if(typeof(res.data.verification) !== 'undefined' && res.data.verification === 'device') {
                this.setState({ showDeviceVerification: true, deviceVerificationSessionId: res.data.session_id });
            } else {
                this.returnToPath();
                this.props.loadUser();
            }
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                let state = { loading: false };
                if(typeof err.response.data.email_not_verified !== 'undefined') {
                    state['emailNotVerified'] = err.response.data.email_not_verified;
                }

                displayErrors(err.response.data);
                this.setState(state);
            }
        });
    }

    requestVerification() {
        this.setState({ requestingVerification: true });

        let email = this.state.email.trim();

        if(email.length === 0) {
            return message.error('Please enter your email address!');
        }

        let data = { email };

        this.props.requestVerification(data, () => {
            message.success('Verification successfully requested! Please check your mailbox!');
            this.setState({ requestingVerification: false, emailNotVerified: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ requestingVerification: false });
            }
        });
    }

    verify2Fa() {
        this.setState({ verifying: true });

        let code = this.state.user2FACode.trim();

        if(code === '') {
            return message.error('Please enter the 6 digit code!');
        }

        let data = {
            session_id: this.state.user2FASessionId,
            code: code.replaceAll(' ', ''),
            code_type: this.state.user2FACodeType
        };

        this.props.verifyUser2FA(data, () => {
            this.returnToPath();
            this.props.loadUser();
            this.setState({ verifying: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ verifying: false });
            }
        });
    }

    verifyDevice() {
        this.setState({ verifyingDevice: true });

        let code = this.state.deviceVerificationCode.trim();
        let remember = this.state.rememberDeviceVerification;

        if(code === '') {
            return message.error('Please enter the 6 digit code!');
        }

        let data = {
            session_id: this.state.deviceVerificationSessionId,
            code: code.replaceAll(' ', ''),
            remember
        };

        this.props.verifyUserDevice(data, () => {
            this.returnToPath();
            this.props.loadUser();
            this.setState({ verifyingDevice: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ verifyingDevice: false });
            }
        })
    }

    render() {
        if(this.props.isAuthenticated) {
            return <Redirect to='/' />;
        }

        const { Option } = Select;
        const queryString = qs.parse(this.props.location.search.substring(1));

        if(typeof(queryString.registration) !== 'undefined' && queryString.registration === 'successful') {
            return(
                <div className='auth-wrapper'>
                    <Card className='form-container login'>
                        <div className='logo-container'>
                            <img alt='Priority Prospect' src='/img/logo.svg' />
                        </div>

                        <Form layout='vertical'>
                            <Fragment>
                                <Row>
                                    <Col span={24}>
                                        <div className='text-center'>
                                            <p><b>Check your email!</b></p>
                                            <p>We just sent you a message! Please check your inbox and click the link to confirm your email address.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Fragment>
                        </Form>
                    </Card>
                </div>
            );
        } else {
            const show2FAForm = <Fragment>
                <Form.Item label='Select code type'>
                    <Select value={this.state.user2FACodeType} onChange={(value) => this.setState(({ user2FACodeType: value }))}>
                        <Option value='CODE'>Code</Option>
                        <Option value='BACKUP_CODE'>Backup code</Option>
                    </Select>
                </Form.Item>
                <Form.Item label='Please enter 6 digit code'>
                    <Input maxLength={this.state.user2FACodeType === 'CODE' ? 6 : 10}
                           ref={(input) => this.tfaInput = input}
                           onKeyUp={(e) => e.key === 'Enter' ? this.verify2Fa() : ''}
                           onChange={(e) => this.setState({ user2FACode: e.target.value })} />
                </Form.Item>
                <Button type='primary' block
                        disabled={this.state.verifying}
                        loading={this.state.verifying}
                        onClick={() => this.verify2Fa()}>Verify</Button>
            </Fragment>;

            const showDeviceVerificationForm = <Fragment>
                <p><b>Verify it's you</b></p>
                <p>We sent a verification code to your email. Enter the code from the email in the field below.</p>
                <Form.Item label='Please enter 6 digit code'>
                    <Input maxLength={6}
                           ref={(input) => this.deviceVerificationInput = input}
                           onKeyUp={(e) => e.key === 'Enter' ? this.verify2Fa() : ''}
                           onChange={(e) => this.setState({ deviceVerificationCode: e.target.value })} />
                </Form.Item>
                <Form.Item>
                    <Checkbox value={this.state.rememberDeviceVerification}
                              onChange={(e) => this.setState({ rememberDeviceVerification: e.target.checked })}>Trust this device for 60 days?</Checkbox>
                </Form.Item>
                <Button type='primary' block
                        disabled={this.state.verifyingDevice}
                        loading={this.state.verifyingDevice}
                        onClick={() => this.verifyDevice()}>Verify code</Button>
            </Fragment>;

            let content = <Fragment>
                <Form.Item>
                    <Input type='email'
                           value={this.state.email}
                           ref={(input) => this.emailInput = input}
                           placeholder='Email address'
                           onKeyUp={(e) => e.key === 'Enter' ? this.login() : ''}
                           onChange={(e) => this.setState({ email: e.target.value })} />
                </Form.Item>
                <Form.Item>
                    <Input.Password
                        ref={(input) => this.passwordInput = input}
                        value={this.state.password}
                        placeholder='Password'
                        onKeyUp={(e) => e.key === 'Enter' ? this.login() : ''}
                        onChange={(e) => this.setState({ password: e.target.value })} />
                </Form.Item>
                {this.state.emailNotVerified ? <Row>
                    <Col span={24} className='text-center'>
                        <Button disabled={this.state.requestingVerification}
                                loading={this.state.requestingVerification}
                                style={{marginBottom: '10px'}}
                                block
                                onClick={() => this.requestVerification()}>Request new verification email</Button>
                    </Col>
                </Row>: ''}
                <Row>
                    <Col span={24}>
                        <Form.Item>
                            <Button type='primary' block
                                    disabled={this.state.loading}
                                    loading={this.state.loading}
                                    onClick={() => this.login()}>Login</Button>

                            <div className='auth-mobile-button'>
                                <Link to={'/auth/register' + window.location.search}>
                                    <Button block style={{marginTop: '15px'}}>Create Account</Button>
                                </Link>
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center'>
                        <Link to={'/auth/recover' + window.location.search}>Forgot password?</Link>
                    </Col>
                </Row>
            </Fragment>;

            if(this.state.show2FA) {
                content = show2FAForm;
            } else if(this.state.showDeviceVerification) {
                content = showDeviceVerificationForm;
            }

            return(
                <div className='auth-wrapper'>
                    <Card className='form-container login'>
                        <div className='logo-container'>
                            <img alt='Priority Prospect' src='/img/logo.svg' />
                        </div>

                        <Form layout='vertical'>
                            {content}
                        </Form>
                    </Card>
                </div>
            );
        }
    }
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    loading: state.auth.isLoading
});

export default connect(mapStateToProps, { updatePage, login, loadUser, requestVerification,
    fetchWhiteLabelData, verifyUser2FA, verifyUserDevice })(Login);